import errors from './errors.js';
import translation from './translation/index.js';
const ko = Object.freeze({
    translation,
    errors,
});
export default ko;
